import React from "react";

import TextField from "@mui/material/TextField";
import Checkbox from "@mui/material/Checkbox";
import Button from "@mui/material/Button";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import FormControlLabel from "@mui/material/FormControlLabel";

import {
  Tooltip,
  FormLabel,
  RadioGroup,
  Radio,
  Typography,
  FormGroup,
  InputAdornment,
  useTheme,
} from "@mui/material";

import { parsePartnerURL } from "./utils/applibs";
import ItemsEnumeratorInterface from "../interfaces/ItemsEnumeratorInterface";
import InstagramIcon from "@mui/icons-material/Instagram";
import FacebookIcon from "@mui/icons-material/Facebook";
import PersonIcon from "@mui/icons-material/Person";
import MailIcon from "@mui/icons-material/Mail";
import UploadImage from "./UploadImage";

function BootstrapTooltip(props) {
  return (
    <Tooltip
      arrow
      componentsProps={{ tooltip: { sx: { fontSize: 13 } } }}
      {...props}
    />
  );
}

const AdminMerchant = (props) => {
  const theme = useTheme();
  const classes = {
    root: {
      marginTop: 0,
    },
    platformTitle: {},
    marginRight: {
      marginRight: theme.spacing(4),
    },
    fullWidth: {
      display: "flex",
      flexDirection: "row",
      justifyContent: "space-between",
      margin: "10px 0",
    },
    extraMarginTop: { marginTop: 20 },
    categories: {},
    actions: {
      display: "flex",
      justifyContent: "space-around",
      padding: "10px 0",
    },
    platforms: {},
  };

  const {
    superUser,
    typeShop,
    paymethod,
    email,
    name,
    showDeliverySchedule,
    logoType,
    fileLogo,
    fileBanner,
    fileHero,
    filePartnerLogo,
    address,
    referer,
    currency,
    currencies,
    hasPagination,
    lang,
    langs,
    apikey,
    container,
    editMode,
    tags,
    uitype,
    uiDisplayMode,
    categories,
    facebook,
    instagram,
    emailOwner,
    usershop,
    demo,
    partnerCategories,
    handlePostItem,
    onEmailChange,
    onShowDeliveryScheduleChange,
    onNameChange,
    onFileChange,
    onLogoTypeChange,
    onAddressChange,
    onLangChange,
    onRefererChange,
    onCurrencyChange,
    onPaginationChange,
    onContainerChange,
    onChangeTypeShop,
    onChangePaymethod,
    onChangeLocationPartner,
    onChangeShopPartner,
    submitting,
    locationPartner,
    shopPartner,
    onTagsChange,
    onChangeUIType,
    onChangeUIDisplayMode,
    onCategoriesChange,
    onChangeSocialInsta,
    onChangeSocialFB,
    onChangeUsershop,
    onChangeDemoSite,
    onEmailOwner,
    onCancelAction,
  } = props;

  const hasPaginationFn = () => {
    return (
      hasPagination === "1" || hasPagination === 1 || hasPagination === true
    );
  };

  const typePlatformTitle = editMode
    ? typeShop === "1001"
      ? `Plateforme Kadomi.ch`
      : `Plateform personnel`
    : null;

  const hasCategoriesSelected = (catId) => {
    const categoriesFormatted =
      typeof categories === "string" ? [] : categories;
    const category = categoriesFormatted.find(
      (c) => parseInt(c.id, 10) === parseInt(catId, 10)
    );

    return !!category;
  };

  return (
    <React.Fragment>
      <form noValidate autoComplete="off" style={classes.root}>
        {!editMode ? (
          <React.Fragment>
            <FormLabel component="legend">
              <Typography>Type de shop</Typography>
            </FormLabel>
            <RadioGroup
              aria-label="Type de shop"
              name="gender1"
              value={typeShop}
              onChange={onChangeTypeShop}
            >
              {[
                {
                  id: "0",
                  name: "Inclure la boutique sur mon site personnel",
                  helper:
                    "Vos clients viennent sur votre site pour acheter les articles.",
                },
                {
                  id: "1001",
                  name: "Publier mes articles sur le site partenaire Kadomi.ch",
                  helper:
                    "Vous proposez à vos clients d'acheter vos articles sur le site partenaire https://kadomi.ch",
                },
              ].map((p) => (
                <BootstrapTooltip title={p.helper} key={p.id}>
                  <FormControlLabel
                    value={p.id}
                    control={<Radio />}
                    label={p.name}
                  />
                </BootstrapTooltip>
              ))}
            </RadioGroup>
          </React.Fragment>
        ) : null}

        {editMode ? (
          <FormControlLabel
            style={classes.platformTitle}
            control={
              <Checkbox
                checked={true}
                onChange={() => {}}
                disabled={true}
                name="isPartnerShop"
              />
            }
            label={typePlatformTitle}
          />
        ) : null}

        <FormControlLabel
          control={
            <Checkbox
              checked={demo === "1"}
              onChange={onChangeDemoSite}
              name="demo"
              color="primary"
            />
          }
          label="Site de démo"
        />

        <Select
          labelId="demo-simple-select-label"
          id="demo-simple-select"
          value={uitype}
          label="Age"
          onChange={onChangeUIType}
          style={{ paddingLeft: "10px", marginRight: theme.spacing(4) }}
        >
          <MenuItem value={0}>Aucun</MenuItem>
          <MenuItem value={2}>Card item with Picture</MenuItem>
          <MenuItem value={3}>Button text only</MenuItem>
          <MenuItem value={5}>Do not show items</MenuItem>
          <MenuItem value={6}>Other</MenuItem>
        </Select>

        <Select
          labelId="select-display-mode-label"
          id="select-display-mode"
          value={uiDisplayMode}
          label="Display mode"
          onChange={onChangeUIDisplayMode}
        >
          <MenuItem value={1}>Mode gallerie (par défaut)</MenuItem>
          <MenuItem value={2}>Mode horizontale linéaire</MenuItem>
        </Select>

        {typeShop === "1001" ? (
          <div>
            <TextField
              label="Lieu *"
              margin="normal"
              onChange={onChangeLocationPartner}
              variant="outlined"
              value={locationPartner}
              disabled={false}
            />
            <TextField
              label="Boutique *"
              margin="normal"
              onChange={onChangeShopPartner}
              variant="outlined"
              value={shopPartner}
              disabled={false}
            />
            <FormControl fullWidth>
              <TextField
                label="URL Kadomi"
                margin="normal"
                onChange={() => {}}
                variant="outlined"
                value={parsePartnerURL(locationPartner, shopPartner)}
                disabled={true}
              />
            </FormControl>
            <FormControl style={classes.categories}>
              <FormLabel component="legend">
                Catégorie(s) de votre shop en ligne
              </FormLabel>
              <FormGroup row>
                {partnerCategories.map((c) => (
                  <FormControlLabel
                    key={c.id}
                    control={
                      <Checkbox
                        checked={hasCategoriesSelected(c.id)}
                        onChange={onCategoriesChange}
                        name={c.id}
                      />
                    }
                    label={c.name.fr}
                  />
                ))}
              </FormGroup>
            </FormControl>
            <FormControl fullWidth>
              <TextField
                label="Page Facebook"
                margin="normal"
                onChange={onChangeSocialFB}
                variant="outlined"
                value={facebook}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <FacebookIcon />
                    </InputAdornment>
                  ),
                }}
              />
            </FormControl>
            <FormControl fullWidth>
              <TextField
                label="Compte Instagram"
                margin="normal"
                onChange={onChangeSocialInsta}
                variant="outlined"
                value={instagram}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <InstagramIcon />
                    </InputAdornment>
                  ),
                }}
              />
            </FormControl>
            <FormControl>
              <TextField
                label="Nom d'utilisateur associé au shop *"
                margin="normal"
                onChange={onChangeUsershop}
                variant="outlined"
                value={usershop}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <PersonIcon />
                    </InputAdornment>
                  ),
                }}
              />
            </FormControl>
            <FormControl>
              <TextField
                label="Email de contact *"
                margin="normal"
                onChange={onEmailOwner}
                variant="outlined"
                value={emailOwner}
                type="email"
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <MailIcon />
                    </InputAdornment>
                  ),
                }}
              />
            </FormControl>
            <ItemsEnumeratorInterface
              style={classes.extraMarginTop}
              title={`Mot-clés associés à votre shop`}
              values={typeof tags === "string" ? tags.split(",") : tags}
              type={`tags`}
              canDelete={false}
              onChange={onTagsChange}
            ></ItemsEnumeratorInterface>
          </div>
        ) : null}

        {typeShop === "0" ? (
          <React.Fragment>
            <FormControl fullWidth>
              <TextField
                label="Nom du point de vente / boutique"
                margin="normal"
                onChange={onNameChange}
                variant="outlined"
                value={name}
              />
            </FormControl>

            {/* add a checkbox to choose delivery mode display (show delivery schedule or not) */}
            <FormControlLabel
              control={
                <Checkbox
                  checked={showDeliverySchedule}
                  onChange={onShowDeliveryScheduleChange}
                  name="showDeliverySchedule"
                  color="primary"
                />
              }
              label="Afficher le calendrier de livraison"
            />

            <FormControl fullWidth style={{ marginTop: theme.spacing(2) }}>
              <UploadImage
                disabled={logoType < 1}
                onFileChange={onFileChange}
              />

              <RadioGroup
                style={{ marginTop: theme.spacing(2) }}
                aria-labelledby="demo-radio-buttons-group-label"
                value={logoType}
                onChange={onLogoTypeChange}
                name="radio-buttons-group"
              >
                <FormControlLabel
                  value="1"
                  control={<Radio />}
                  label="Photo de logo du shop"
                />
                <FormControlLabel
                  value="2"
                  control={<Radio />}
                  label="Photo de la bannière figurant sur l'email"
                />
                <FormControlLabel
                  value="3"
                  control={<Radio />}
                  label="Photo de la bannière Hero du site"
                />
                <FormControlLabel
                  value="4"
                  control={<Radio />}
                  label="Photo du logo partenaire au bas de l'email"
                />
              </RadioGroup>

              {/* logo */}
              <div
                style={{
                  marginTop: theme.spacing(2),
                  marginBottom: theme.spacing(4),
                  display: "flex",
                  gap: 20,
                  alignItems: "center",
                  flexWrap: "wrap",
                  backgroundColor: "#f4f4f4",
                  padding: 20,
                }}
              >
                {fileLogo && (
                  <div>
                    <div>Logo actuel</div>
                    <img
                      src={`${process.env.REACT_APP_BUCKETS3}${fileLogo}`}
                      alt="Logo"
                      style={{ maxHeight: 80 }}
                    />
                  </div>
                )}
                {fileBanner && (
                  <div>
                    <div>Banner actuel</div>
                    <img
                      src={`${process.env.REACT_APP_BUCKETS3}${fileBanner}`}
                      alt="Banner"
                      style={{ maxHeight: 80 }}
                    />
                  </div>
                )}
                {fileHero && (
                  <div>
                    <div>Hero actuel</div>
                    <img
                      src={`${process.env.REACT_APP_BUCKETS3}${fileHero}`}
                      alt="Hero"
                      style={{ maxHeight: 80 }}
                    />
                  </div>
                )}
                {filePartnerLogo && (
                  <div>
                    <div>Logo partenaire actuel</div>
                    <img
                      src={`${process.env.REACT_APP_BUCKETS3}${filePartnerLogo}`}
                      alt="Logo partenaire"
                      style={{ maxHeight: 80 }}
                    />
                  </div>
                )}
              </div>
            </FormControl>
            <div
              style={{
                ...classes.fullWidth,
                justifyContent: "flex-start",
              }}
            >
              <TextField
                label="Identification du site"
                onChange={() => {}}
                style={classes.marginRight}
                variant="outlined"
                value={apikey}
                disabled={true}
              />
              <TextField
                label="Email du responsable du site"
                onChange={onEmailChange}
                variant="outlined"
                value={email}
                disabled={true}
              />
            </div>
            <FormControl fullWidth>
              <TextField
                label="Lieu"
                margin="normal"
                onChange={onAddressChange}
                variant="outlined"
                value={address}
              />
            </FormControl>
            <FormControl fullWidth>
              <BootstrapTooltip
                title={`Veuillez vous assurer que l'URL (ou adresse) de votre site soit toujours accessible en navigation sécurités (HTTPS et non HTTP)`}
              >
                <TextField
                  label="Url du site"
                  margin="normal"
                  onChange={onRefererChange}
                  variant="outlined"
                  value={referer}
                />
              </BootstrapTooltip>
            </FormControl>
            <div style={classes.fullWidth}>
              <TextField
                label={`Langue (${langs.map((l) => l.code).join(", ")})`}
                onChange={onLangChange}
                variant="outlined"
                value={lang}
              />
              <TextField
                label={`Devise (${currencies.map((c) => c.code).join(", ")})`}
                onChange={onCurrencyChange}
                variant="outlined"
                value={currency}
              />
              <BootstrapTooltip
                title={`Optionel: spécifie un 'conteneur' au nom unique sur votre page web destiné à afficher votre shopping. Si ce champ est remplie, veuillez ajouter le conteneur suivant sur votre page web : <div="${container}"></div>`}
              >
                <TextField
                  label="Identifiant de l'emplacement"
                  onChange={onContainerChange}
                  variant="outlined"
                  value={container}
                />
              </BootstrapTooltip>
            </div>
            {false ? (
              <div style={classes.fullWidth}>
                <FormControl>
                  <FormLabel id="demo-controlled-radio-buttons-group">
                    Passerelle de paiement
                  </FormLabel>
                  <RadioGroup
                    aria-labelledby="demo-controlled-radio-buttons-group"
                    name="controlled-radio-buttons-group"
                    value={paymethod}
                    onChange={onChangePaymethod}
                  >
                    <FormControlLabel
                      value="1"
                      control={<Radio />}
                      label="DATATRANS"
                    />{" "}
                    <FormControlLabel
                      value="3"
                      control={<Radio />}
                      label="STRIPE"
                    />
                  </RadioGroup>
                </FormControl>
              </div>
            ) : null}
            <FormControlLabel
              control={
                <Checkbox
                  checked={hasPaginationFn()}
                  onChange={onPaginationChange}
                  name="checkedB"
                  color="primary"
                />
              }
              label="Pagination & Filtres"
            />
          </React.Fragment>
        ) : null}

        <FormControl fullWidth></FormControl>
        <div style={classes.actions}>
          {!superUser ? (
            <Button
              variant="contained"
              disabled={
                submitting ||
                (typeShop === "1001" &&
                  (locationPartner === "" ||
                    shopPartner === "" ||
                    usershop === ""))
              }
              onClick={handlePostItem}
            >
              {submitting ? "processing ..." : "Sauver"}
            </Button>
          ) : null}
          <Button
            variant="contained"
            disabled={submitting}
            onClick={onCancelAction}
          >
            Annuler
          </Button>
        </div>
      </form>
    </React.Fragment>
  );
};

export default AdminMerchant;
